import gql from 'graphql-tag';

/**
 * Dedicated mutation for archiving a campaign order.
 *
 * This mutation:
 * 1. Nullifies adProviderId on all associated campaigns (disconnects from DSP)
 * 2. Nullifies adProviderId on all associated line items
 * 3. Sets the campaign order status to ARCHIVED
 *
 * Use this instead of EDIT_CAMPAIGN_STATUS when archiving to ensure
 * proper DSP disconnection.
 */
const ARCHIVE_CAMPAIGN_ORDER = gql`
  mutation archiveCampaignOrder($id: ID!) {
    archiveCampaignOrder(where: { id: $id }) {
      id
      name
      status
    }
  }
`;

export default ARCHIVE_CAMPAIGN_ORDER;
